import { claimTooltip, releaseTooltip } from '@/lib/tooltipRegistry';
import { cn } from '@/lib/utils';
import { FunctionComponent, useEffect, useId, useRef } from 'react';
import { createPortal } from 'react-dom';
import { ITooltip, Tooltip, type TooltipRefProps } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

interface iPortalTooltipProps extends ITooltip {}

const PortalTooltip: FunctionComponent<iPortalTooltipProps> = ({ children, style = {}, afterShow, afterHide, ...props }) => {
  const ref = useRef<TooltipRefProps>(null);
  const slotId = `tip-${useId()}`;
  // A controlled tooltip (`isOpen`, e.g. a hint) holds the shared slot through its owner.
  const controlled = props.isOpen !== undefined;
  useEffect(() => () => releaseTooltip(slotId), [slotId]);
  const container = document.getElementById('tooltip');
  if (!container) return null;
  return createPortal(
    <Tooltip
      openEvents={{ mouseover: true, focus: false }}
      {...props}
      ref={ref}
      // One tooltip open at a time, app-wide, hints included (fb2 M3).
      afterShow={() => {
        if (!controlled) claimTooltip(slotId, () => ref.current?.close());
        afterShow?.();
      }}
      afterHide={() => {
        if (!controlled) releaseTooltip(slotId);
        afterHide?.();
      }}
      disableStyleInjection
      className={cn(
        'tooltip bg-slate-700! dark:bg-stone-800! opacity-95! backdrop-blur-md! dark:border! dark:border-stone-700/20! rounded-[5px]!',
      )}
      style={{
        // backgroundColor: 'rgb(51, 65, 85)',
        padding: '4px 10px',
        fontFamily: 'Geist',
        fontWeight: 500,
        fontSize: '14px',
        ...style,
        zIndex: 9999,
      }}>
      {children}
    </Tooltip>,
    container,
  );
};

export default PortalTooltip;
